module.exports = {
	"main": {
		"googleAnalyticsCode": "UA-45029200-7",
		"urls": {
			"styles": {
				"fallback": "https://dryxtm33bfdqu.cloudfront.net/assets/fallback.css",
				"assets": "https://dryxtm33bfdqu.cloudfront.net/assets"
			},
			"home-quote": "https://insurance.ama.ab.ca/quote/home/quotes/new",
			"auto-quote": "https://ins.ama.ab.ca/auto/",
			"PAI-quote": "https://ama.ab.ca/insurance/products/4-personal-accident-insurance",
			"contact": "https://ama.ab.ca/membership/contact-us--centre-locations-hours-and-contact-information"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/config/appConfig.json
// module id = 377
// module chunks = 0